<style src="./EmployeeWalletCreditReport.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="row">
          <div class="col-lg-4">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="col-sm-12">Data</label>
                <div class="col-sm-12">
                  <input
                    type="date"
                    class="form-control"
                    v-model="date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Total de Vendas</th>
            <th>Quantidade de Vendas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.employeeName }}</td>
            <td>R$ {{ toCurrencyBR(item.totalCreditToUser) }}</td>
            <td>{{ item.count }}</td>
          </tr>
          <tr v-if="!showSpinner && resultList.length === 0">
            <td colspan="3" class="text-center">Nenhum resultado encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      date: this.todayString(),
      resultList: [],
      totals: 0,
    };
  },
  methods: {
    todayString() {
      const dt = new Date();
      const mm = ('0' + (dt.getMonth() + 1)).slice(-2);
      const dd = ('0' + dt.getDate()).slice(-2);
      return `${dt.getFullYear()}-${mm}-${dd}`;
    },
    toCurrencyBR(value) {
      if (!value && value !== 0) return '-';
      return (value / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    async filterReport() {
      this.showSpinner = true;
      this.resultList = [];

      const query = {
        date: new Date(`${this.date}T12:00:00`),
      };

      try {
        const result = await this.$store.dispatch('REPORTS/EmployeeWalletCredit', { query });
        this.resultList = result.employees || [];
        this.totals = result.totals || 0
      } catch {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>
